export const ADMIN_LOGIN = `/admin/auth`;
export const GET_PERMISSION = `/admin/auth/permission`;